<template>
  <div class="x-view crv">
    <header class="head head--accent">
      <div class="head__text">
        <div class="head__eyebrow">
          <span class="head__dot"></span>WaizmannVergleich / START
        </div>
        <h1 class="head__title">Welche Zusatzversicherung wollen Sie vergleichen?</h1>
        <p class="head__sub">
          Wählen Sie Ihre Sektion und erhalten Sie Ihren persönlichen Vergleich
          der besten Tarife.
        </p>
      </div>
    </header>

    <div class="x-grid">
      <main class="x-main crv__main">
        <section class="crv__sec">
          <StartZahnNew />
        </section>

        <section class="crv__sec">
          <StartZusatzNew />
        </section>
      </main>

      <aside class="x-aside crv__aside" v-if="!sharedDataStore.isMobile()">
        <article class="cls">
          <div class="cls__banner">
            <span class="cls__banner-eyebrow">EXKLUSIV</span>
            <h3 class="cls__banner-title">Clearment VertragsSchutz</h3>
          </div>
          <div class="cls__body">
            <div class="cls__logo">
              <img
                :src="require('@/assets/clearmentai/clearmentai.png')"
                alt="Clearment"
              />
            </div>
            <p class="cls__lead">
              Der <b>Clearment VertragsSchutz</b> sichert Ihre vertraglich
              zugesicherten Leistungen ab &mdash; damit Ihre Versicherung auch
              wirklich leistet, wenn Sie diese brauchen.
            </p>
            <ul class="cls__list">
              <li>
                <v-icon size="16" color="#2e7d32">mdi-shield-check-outline</v-icon>
                <span>Absicherung Ihrer Vertragsleistungen</span>
              </li>
              <li>
                <v-icon size="16" color="#2e7d32">mdi-shield-check-outline</v-icon>
                <span>Rechtliche Unterstützung im Leistungsfall</span>
              </li>
              <li>
                <v-icon size="16" color="#2e7d32">mdi-shield-check-outline</v-icon>
                <span>Kostenlos für gesamte Vertragslaufzeit</span>
              </li>
            </ul>
            <div class="cls__hint">
              <v-icon size="13" color="#5b6473">mdi-information-outline</v-icon>
              <span>Bei ausgewählten Tarifen automatisch inklusive.</span>
            </div>
            <a class="cls__link" href="https://www.clearment.de" target="_blank" rel="noopener">
              www.clearment.de
              <v-icon size="14">mdi-arrow-right</v-icon>
            </a>
          </div>
        </article>

        <article class="avb">
          <div class="avb__head">
            <span class="avb__eyebrow">
              <span class="head__dot"></span>VORTEILE
            </span>
            <h3 class="avb__title">Warum WaizmannVergleich?</h3>
          </div>
          <ul class="avb__list">
            <li>
              <span class="avb__check">
                <v-icon size="14" color="#2e7d32">mdi-check-bold</v-icon>
              </span>
              <span>Das Original &mdash; seit 1995</span>
            </li>
            <li>
              <span class="avb__check">
                <v-icon size="14" color="#2e7d32">mdi-check-bold</v-icon>
              </span>
              <span>Nr.&nbsp;1 für Zahnzusatzversicherungen</span>
            </li>
            <li>
              <span class="avb__check">
                <v-icon size="14" color="#2e7d32">mdi-check-bold</v-icon>
              </span>
              <span>Von über 14.000 Zahnärzten empfohlen</span>
            </li>
          </ul>
        </article>
      </aside>
    </div>
  </div>
</template>

<script setup>
import { getCurrentInstance, onMounted } from "vue";
import StartZahnNew from "@/views/rechner/mini/StartZahnNew";
import StartZusatzNew from "@/views/rechner/mini/StartZusatzNew";
import { useBerechnungStore } from "@/stores/berechnung";
import { useSharedDataStore } from "@/stores/sharedData";

const sharedDataStore = useSharedDataStore();
const berechnungStore = useBerechnungStore();
const { proxy } = getCurrentInstance();

onMounted(() => {
  berechnungStore.setShowFooter(false);
  proxy.$updateDocumentHead(
    "Welche Zusatzversicherung wollen Sie vergleichen?",
    "Alle WaizmannTabelle Zusatzversicherungs-Rechner"
  );
});
</script>

<style scoped>
.x-view {
  width: 100%;
  max-width: 1180px;
  margin: 0 auto;
  padding: 16px 20px;
}
.x-grid {
  display: grid;
  grid-template-columns: minmax(0, 1fr) 300px;
  gap: 18px;
  align-items: start;
}
.x-aside {
  position: sticky;
  top: 16px;
  display: flex;
  flex-direction: column;
  gap: 12px;
}
@media (max-width: 960px) {
  .x-grid {
    grid-template-columns: 1fr;
  }
  .x-aside {
    position: static;
  }
}
@media (max-width: 780px) {
  .x-view {
    padding: 10px 12px;
  }
  .head {
    padding: 12px 14px;
  }
  .crv__main {
    gap: 16px;
  }
}

.head {
  background: #ffffff;
  border: 1px solid #d8dde5;
  border-radius: 3px;
  padding: 14px 18px;
  margin-bottom: 14px;
}
.head--accent {
  border-left: 3px solid #0f4c81;
}
.head__eyebrow {
  display: inline-flex;
  align-items: center;
  font-size: 11px;
  font-weight: 700;
  letter-spacing: 1.2px;
  text-transform: uppercase;
  color: #5b6473;
  margin-bottom: 6px;
}
.head__dot {
  width: 6px;
  height: 6px;
  background: #0f4c81;
  display: inline-block;
  margin-right: 8px;
  border-radius: 0;
}
.head__title {
  font-size: clamp(20px, 2.4vw, 26px);
  font-weight: 700;
  letter-spacing: -0.2px;
  color: #0f172a;
  line-height: 1.2;
  margin: 0 0 6px 0;
}
.head__sub {
  font-size: 13.5px;
  line-height: 1.5;
  color: #4b5563;
  margin: 0;
}

.crv__main {
  display: flex;
  flex-direction: column;
  gap: 22px;
}
.crv__sec {
  display: flex;
  flex-direction: column;
  gap: 10px;
}
.crv__sec-head {
  display: flex;
  flex-direction: column;
  gap: 2px;
}
.crv__sec-eyebrow {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  font-size: 11px;
  font-weight: 700;
  letter-spacing: 1.2px;
  text-transform: uppercase;
  color: #0f4c81;
}
.crv__sec-title {
  font-size: clamp(16px, 1.8vw, 18px);
  font-weight: 700;
  letter-spacing: -0.2px;
  color: #0f172a;
  margin: 0;
  line-height: 1.25;
}

.cls {
  background: #ffffff;
  border: 1px solid #d8dde5;
  border-radius: 3px;
  overflow: hidden;
}
.cls__banner {
  background: #fff5cc;
  border-bottom: 1px solid #ffe58f;
  border-left: 3px solid #f6a800;
  padding: 10px 14px;
}
.cls__banner-eyebrow {
  display: inline-block;
  font-size: 10.5px;
  font-weight: 700;
  letter-spacing: 1.3px;
  text-transform: uppercase;
  color: #8a6d00;
  margin-bottom: 2px;
}
.cls__banner-title {
  font-size: 15px;
  font-weight: 700;
  color: #0f172a;
  margin: 0;
  letter-spacing: -0.1px;
  line-height: 1.2;
}
.cls__body {
  padding: 14px;
  display: flex;
  flex-direction: column;
  gap: 12px;
}
.cls__logo {
  display: flex;
  justify-content: flex-start;
}
.cls__logo img {
  max-width: 180px;
  width: 100%;
  height: auto;
  display: block;
}
.cls__lead {
  font-size: 13px;
  line-height: 1.5;
  color: #1f2937;
  margin: 0;
}
.cls__list {
  list-style: none;
  margin: 0;
  padding: 0;
  display: flex;
  flex-direction: column;
  gap: 8px;
  border-top: 1px dashed #eef1f6;
  border-bottom: 1px dashed #eef1f6;
  padding: 10px 0;
}
.cls__list li {
  display: grid;
  grid-template-columns: 18px 1fr;
  gap: 8px;
  align-items: start;
  font-size: 12.5px;
  line-height: 1.45;
  color: #1f2937;
}
.cls__hint {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  font-size: 12px;
  color: #6b7280;
}
.cls__link {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  font-size: 12.5px;
  font-weight: 600;
  color: #0f4c81;
  text-decoration: none;
  letter-spacing: 0.2px;
}
.cls__link:hover {
  text-decoration: underline;
}

.avb {
  background: #ffffff;
  border: 1px solid #d8dde5;
  border-radius: 3px;
  padding: 12px 14px;
}
.avb__head {
  display: flex;
  flex-direction: column;
  gap: 2px;
  margin-bottom: 8px;
}
.avb__eyebrow {
  display: inline-flex;
  align-items: center;
  font-size: 11px;
  font-weight: 700;
  letter-spacing: 1.2px;
  text-transform: uppercase;
  color: #5b6473;
}
.avb__title {
  font-size: 15px;
  font-weight: 700;
  color: #0f172a;
  margin: 0;
  letter-spacing: -0.1px;
}
.avb__list {
  list-style: none;
  margin: 0;
  padding: 0;
  display: flex;
  flex-direction: column;
  gap: 8px;
}
.avb__list li {
  display: grid;
  grid-template-columns: 22px 1fr;
  gap: 6px;
  align-items: center;
  font-size: 12.5px;
  line-height: 1.4;
  color: #1f2937;
  padding-bottom: 8px;
  border-bottom: 1px dashed #eef1f6;
}
.avb__list li:last-child {
  border-bottom: 0;
  padding-bottom: 0;
}
.avb__check {
  width: 22px;
  height: 22px;
  background: #e7f3ea;
  border: 1px solid #c5e1cb;
  border-radius: 3px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
}
</style>
